(ns shared.core.components.components
  (:require [shared.core.components.a :as a]
            [shared.core.components.banner :as banner]
            [shared.core.components.button :as button]
            [shared.core.components.h :as h]
            [shared.core.components.input :as input]
            [shared.core.components.interactive :as interactive]
            [shared.core.components.table :as table]
            [shared.core.components.icon :as icon]
            [shared.core.components.forms.views :as forms]
            [shared.core.components.modals.views :as modals]
            [shared.core.error :as error]
            [shared.core.keybind.views :as keybind]
            [shared.core.components.tooltip :as tooltip]
            [shared.core.components.label :as label]
            [shared.core.components.dropdown :as dropdown]
            [shared.core.components.multiselect-checkbox-dropdown :as multiselect-checkbox-dropdown]
            [shared.core.components.fonts.views :as fonts]
            [shared.core.loading :as loading]
            [shared.core.components.menu :as menu]
            [shared.core.components.toggle :as toggle]
            [shared.core.components.tree :as tree]
            [shared.core.components.pill :as pill]
            [shared.core.components.checkbox :as checkbox]
            [shared.core.components.dragon-drop :as dnd]
            [shared.core.components.radio :as radio]
            [shared.core.account.rainbow.views :as rainbow]
            [shared.core.components.separator :as separator]
            [shared.core.components.tabs :as tabs]
            [shared.core.components.collapsible-panel :as collapsible-panel]
            [shared.core.components.search :as search]
            [shared.core.components.google-maps.views :as google-maps]
            [shared.core.components.number-picker :as number-picker]
            [shared.core.components.date-picker :as date-picker]
            [shared.core.components.dot :as dot]
            [shared.core.components.input-range :as input-range]
            [shared.core.components.responsive :as responsive]
            [shared.core.components.theme :as theme]
            [shared.core.components.auth0.views :as auth0]
            [shared.core.components.resize-bar.views :as resize-bar]
            ))

(def a a/a)
(def red-a a/red-a)
(def white-a a/white-a)
(def primary-a a/primary-a)

(def banner banner/banner)

(def white-button button/white-button)
(def white-on-background-button button/white-on-background-button)
(def white-borderless-button button/white-borderless-button)
(def green-button button/green-button)
(def green-button-group button/green-button-group)
(def blue-button button/blue-button)
(def red-button button/red-button)
(def red-outline-button button/red-outline-button)
(def error-button button/error-button)
(def primary-button button/primary-button)
(def button-base button/button-base)

(def h1 h/h1)
(def h2 h/h2)
(def h3 h/h3)

(def input input/input)
(def primary-input input/primary-input)
(def round-floating-input input/round-floating-input)
(def textarea input/textarea)
(def json-textarea input/json-textarea)
(def json-textarea-with-schema input/json-textarea-with-schema)

(def interactive interactive/interactive)

(def table table/table)
(def yes-no-boolean table/yes-no-boolean)

(def no-data table/no-data)
(def large-no-data table/large-no-data)
(def primary-table table/primary-table)
(def db-rows-table table/db-rows-table)

(def material-icon icon/material-icon)
(def action-material-icon icon/action-material-icon)
(def material-icon-label icon/material-icon-label)
(def material-icon-tooltip icon/material-icon-tooltip)
(def info-tooltip icon/info-tooltip)
(def copy-icon-tooltip icon/copy-icon-tooltip)
(def phosphor-icon icon/phosphor-icon)

(def form forms/form)

(def modal-view modals/modal-view)
(def modal modals/modal)
(def primary-modal modals/primary-modal)

(def error-message error/error-message)
(def error-messages error/error-messages)

(def keybind-text keybind/keybind-text)
(def keybind-text-cmp keybind/keybind-text-cmp)

(def tooltip tooltip/tooltip)

(def label label/label)
(def primary-label label/primary-label)

(def dropdown dropdown/dropdown)
(def primary-dropdown dropdown/primary-dropdown)
(def fonts-dropdown fonts/fonts-dropdown)

(def multiselect-checkbox-dropdown multiselect-checkbox-dropdown/multiselect-checkbox-dropdown)

(def spinner loading/spinner)
(def primary-spinner loading/primary-spinner)
(def spinner-block loading/spinner-block)
(def loader-rectangle loading/loader-rectangle)

(def menu menu/menu)
(def label-menu menu/label-menu)

(def toggle toggle/toggle)

(def tree tree/tree)
(def large-tree-action tree/large-tree-action)
(def standard-tree-contents tree/standard-tree-contents)
(def mini-tree tree/mini-tree)

(def pill pill/pill)
(def light-gray-pill pill/light-gray-pill)
(def light-gray-on-background-pill pill/light-gray-on-background-pill)
(def click-to-copy-pill pill/click-to-copy-pill)

(def checkbox checkbox/checkbox)
(def small-checkbox checkbox/small-checkbox)

(def dragon-drop-list dnd/dragon-drop-list)
(def dropzone dnd/dropzone)
(def drop-message-box dnd/drop-message-box)

(def radio radio/radio)
(def pill-radio radio/pill-radio)
(def small-radio radio/small-radio)

(def rainbow-setting rainbow/rainbow-setting)

(def tabs tabs/tabs)
(def primary-tabs tabs/primary-tabs)
(def tab tabs/tab)

(def separator separator/separator)
(def or-separator separator/or-separator)
(def spacer separator/spacer)

(def collapsible-panel collapsible-panel/collapsible-panel)

(def search search/search)
(def search-tree search/search-tree)

(def google-map-iframe google-maps/map-iframe)
(def google-places-autocomplete google-maps/places-autocomplete)
(def google-places-autocomplete-input google-maps/places-autocomplete-input)

(def large-number-picker number-picker/large-number-picker)
(def number-picker number-picker/number-picker)
(def mini-number-picker number-picker/mini-number-picker)
(def pill-number-picker number-picker/pill-number-picker)

(def date-picker date-picker/date-picker)
(def primary-date-picker date-picker/primary-date-picker)

(def dot dot/dot-base)
(def red-dot dot/red-dot)
(def yellow-dot dot/yellow-dot)
(def green-dot dot/green-dot)

(def input-range input-range/input-range)
(def primary-input-range input-range/primary-input-range)

(def resp responsive/resp)

(def theme theme/theme)
(def dark-theme-toggle theme/dark-theme-toggle)

(def auth0-wrapper auth0/auth0-wrapper)
(def auth0-root-view auth0/auth0-root-view)

(def resize-bar resize-bar/resize-bar)
